import { AuthenticateFromOauthExchangeMutation, AuthenticateFromOauthExchangeMutationVariables, AuthenticateFromOauthValidateMutation, AuthenticateFromOauthValidateMutationVariables } from '@src/types/__generated/rewareRestUserTypes';
import { exec } from '../utils';

const gql = String.raw;

const VALIDATE_QUERY = gql`
  mutation authenticateFromOauthValidate(
    $token: String!
    $userId: Int!
  ) {
    authenticateFromOauth(
      token: $token
      userId: $userId
    ) {
      uuid
      name
      email
    }
  }
`;

const EXCHANGE_QUERY = gql`
  mutation authenticateFromOauthExchange(
    $token: String!
    $userId: Int!
  ) {
    authenticateFromOauth(
      token: $token
      userId: $userId
    ) {
      oneTimeToken
    }
  }
`;


/**
 * Validates JWT and returns user info (used during login)
 */
export const authenticateFromOauth = async (
  params: AuthenticateFromOauthValidateMutationVariables
) => {
  const data = await exec<AuthenticateFromOauthValidateMutationVariables, AuthenticateFromOauthValidateMutation>(
    VALIDATE_QUERY,
    {
      variables: params,
    },
  );

  return data.authenticateFromOauth;
};

/**
 * Exchanges JWT for a one-time badge token (used for API calls)
 */
export const exchangeJwtForBadgeToken = async (
  params: AuthenticateFromOauthExchangeMutationVariables
): Promise<string> => {
  const data = await exec<AuthenticateFromOauthExchangeMutationVariables, AuthenticateFromOauthExchangeMutation>(
    EXCHANGE_QUERY,
    {
      variables: params,
    },
  );

  if (!data.authenticateFromOauth) {
    throw new Error('No token found');
  }
  return data.authenticateFromOauth.oneTimeToken!;
};
